import {
  Button,
  Grid,
  Tooltip,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";
import { ArrowDownward, Block, MoneyOffSharp, Save } from "@material-ui/icons";
import CloseIcon from "@material-ui/icons/Close";
import Config, {
  DEFAULT_GET_WARRANTY,
  PERMISSION_ROLE_HIS_PAYMENT,
  PROMOTION_CODES,
  PROMOTION_DEFAULT_CODE,
  REQUIRED_CTKM,
} from "app/appConfig";
import CommonButton from "app/common/Component/Button/CommonButton";
import ConfirmPopup from "app/common/Component/Popup/ConfirmPopup";
import PopupForm from "app/common/Component/Popup/PopupForm";
import GlobitsAutocomplete from "app/common/form/GlobitsAutocomplete";
import GlobitsCheckBox from "app/common/form/GlobitsCheckBox";
import GlobitsDateTimePicker from "app/common/form/GlobitsDateTimePicker";
import GlobitsPagingAutocomplete from "app/common/form/GlobitsPagingAutocomplete";
import GlobitsTextField from "app/common/form/GlobitsTextField";
import GlobitsVNDCurrencyInput from "app/common/form/GlobitsVNDCurrencyInput";
import GlobitsVNDCurrencyInputOnlyChange from "app/common/form/GlobitsVNDCurrencyInputOnlyChange";
import useDefaultDepartment from "app/common/hooks/useDefaultDepartment";
import IconDelete from "app/common/Icon/IconDelete";
import {
  INVOICE_PAID,
  INVOICE_PARTIAL_PAID,
  LEAD_SOURCE_LEVEL,
  PathModule,
  POPUP_TYPE_REGISTER_TREATMENT,
  PromotionTypeEnum,
  SERVICE_TREATMENT_TYPE_TREATMENT_BY_VOLUME,
  STATUS_TREATMENT_LOCK,
  TYPE_CARD,
} from "app/common/LocalConst";
import {
  formatMoney,
  getPriceTypeService,
  handleDefaultServiceWarranty,
  isAdmin,
  isRoleHisPayment,
  validateEqualsSourceDiffirentTelesale,
  validateMaxTotalAmountTelesale,
  validateMaxTotalDiffTelesale,
  validateSelectDiffirentTelesale,
  validateSelectTelesale,
} from "app/common/LocalFunction";
import DeductionList from "app/PatientManagement/DeductionList/DeductionList";
import { pagingClientCard } from "app/services/ClientCardService";
import { getListCode } from "app/services/CustomerSourceService";
import { pagingDepartment } from "app/services/DepartmentService";
import { pagingDrug } from "app/services/DrugService";
import { pagingHealthCareService } from "app/services/HealthCareService";
import { pagingProgramGetId } from "app/services/PromotionCRMService";
import { useStore } from "app/stores";
import { getIn, useFormikContext } from "formik";
import { observer } from "mobx-react";
import { forwardRef, memo, useEffect, useState } from "react";
import { toast } from "react-toastify";
import { filterBaseOptions } from "utils";
import * as Yup from "yup";
import PaymentVoucherPopup from "../../FeeTab/Popup/PaymentVoucherPopup";
import PromotionFreePopup from "../../FeeTab/Popup/PromotionFreePopup";
import RowTotalTreatmentPlan from "../../RegisterProductTab/Component/RowTotalTreatmentPlan";
import PaServiceRegisterTable, {
  renderOptionsDrug,
  renderOptionsService,
} from "../Component/PaServiceRegisterTable";
import RegisterServiceStaffsRevenue from "./RegisterServiceStaffsRevenue";
/*
 * Popup thêm/sửa liệu trình
 */
const RegisterTreatmentPlanPopupTotalItem = ({
  open,
  handleClose,
  onSubmit,
  initRegisterTreatmentPlan,
  listVatPercent,
  customerSourceWalkIn,
  listStk,
  listPaymentMethod,
  handleAfterSubmit,
  departmentsUser,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("xs"));

  const { listCodeSource } =
    useStore().patientManagementStore.registerTreatmentPlanStore;

  const { handleGetListVatPercent, initialPatient } =
    useStore().patientManagementStore.patientGeneralStore;

  //const startDateChanged = values.startDate !== initialValues.startDate;
  // const [listCodeSourceValidate, setListCodeSourceValidate] = useState(listCodeSource || []);

  const handleGetListCodeSource = async (obj, setFieldValue) => {
    try {
      const { data } = await getListCode(obj);
      setFieldValue("listCodeSource", data || []);
    } catch (error) {
      //console.error(error);
    }
  };

  const department = useDefaultDepartment();

  useEffect(() => {
    handleGetListVatPercent();
  }, []);

  const validationSchema = Yup.object().shape({
    department: Yup.object().nullable().required("Chưa cơ sở!"),
    price: Yup.number()
      .min(0, "Giá phải lớn hơn 0!")
      .nullable()
      .required("Chưa nhập giá!"),
    staffRevenues: Yup.array()
      .min(1, "Cần thêm ít nhất 1 phân bổ!")
      .of(
        Yup.object()
          .shape({
            position: Yup.object()
              .nullable()
              .required("Bắt buộc nhập chức danh"),
            staff: Yup.object().nullable(),
            source: Yup.object()
              .nullable()
              .required("Bắt buộc nhập nguồn phân bổ")
              .test(
                "source-in-list",
                "Nguồn phân bổ không hợp lệ",
                function (value) {
                  const listCodeSource =
                    this.options.context?.listCodeSource || [];

                  // Nếu chưa chọn hoặc thiếu code → invalid
                  if (!value || !value.code) return false;

                  // Không có danh sách thì cho pass
                  if (listCodeSource.length === 0) return true;

                  const first = listCodeSource[0];

                  // Mảng string: ["CTV", "KR", ...]
                  if (typeof first === "string") {
                    return listCodeSource.includes(value.code);
                  }

                  // Mảng object: [{code: "CTV"}]
                  if (typeof first === "object" && first !== null) {
                    return listCodeSource.some(
                      (item) => item.code === value.code
                    );
                  }

                  return false;
                }
              ),
            actualAmount: Yup.mixed()
              .nullable()
              .test("greater-than-zero", "Giá trị phải lớn hơn 0!", (value) => {
                if (value === null || value === "") return true;
                return typeof value === "number" && value >= 0;
              }),
            percentRevenue: Yup.mixed()
              .nullable()
              .test(
                "max-100",
                "Phân bổ doanh thu phải nhỏ hơn hoặc bằng 100!",
                (value) => {
                  if (value === null || value === "") return true;
                  return typeof value === "number" && value <= 100;
                }
              ),
          })
          .test(
            "at-least-one-selected",
            "Phải chọn Nhân viên!",
            function (value) {
              if (!value) return false;
              const { staff } = value;
              return !!staff;
            }
          )
      )
      .test(
        "at-least-one-diffirent-sale",
        "Cần chọn phân bổ cho người tư vấn !",
        validateSelectDiffirentTelesale
      )
      .test(
        "at-least-one-sale",
        "Cần chọn phân bổ cho telesale!",
        validateSelectTelesale
      )

      .test(
        "max-total-amount-telesale",
        "Tổng phân bổ telesale phải bằng 100%",
        validateMaxTotalAmountTelesale
      )
      .test(
        "max-total-amount-consultant",
        "Tổng phân bổ tư vấn viên và kĩ thuật viên phải bằng 100%",
        validateMaxTotalDiffTelesale
      )
      .test(
        "equals-source-revenue-sale-diffirent",
        "Tổng % tên nguồn của TELESALE phải bằng tổng % tên nguồn của các chức danh khác TELESALE",
        validateEqualsSourceDiffirentTelesale
      )
      .nullable(),
    paServiceRegister: Yup.array()
      .of(
        Yup.object().shape({
          price: Yup.number()
            .min(0, "Giá phải lớn hơn 0!")

            .nullable(),
          discount: Yup.number().min(0, "Giảm giá phải lớn hơn 0!").nullable(),
          amount: Yup.number()
            .typeError("Thành tiền phải là số")
            .test(
              "validate-amount",
              "Không được bán dưới mức giá tối thiểu",
              function (amount) {
                const { quantity, service } = this.parent;
                if (!quantity || !service?.minSellingPrice || !amount) {
                  return true;
                } else {
                  let minSellingPriceVal = amount / quantity;
                  if (minSellingPriceVal < service?.minSellingPrice) {
                    return false;
                  }
                  return true;
                }
              }
            )

            .nullable(),
          percentDiscount: Yup.number()
            .max(100, "Giảm giá phải nhỏ hơn 100!")
            .test(
              "validate-percentDiscount",
              "Không được quá % giảm giá của chương trình khuyến mãi này",
              function (value) {
                const { promotionProgram } = this.parent;

                // 👉 CHỈ validate khi có promotionProgram
                if (!promotionProgram) return true;

                // Nếu không thuộc nhóm code cần validate → bỏ qua
                if (!PROMOTION_CODES?.includes(promotionProgram?.code)) return true;

                if (
                  promotionProgram.allProductMaxDiscountPercent != null &&
                  value > promotionProgram.allProductMaxDiscountPercent
                ) {
                  return false;
                }

                if (
                  promotionProgram.products?.length > 0 &&
                  value > promotionProgram.products[0]?.maxDiscountPercent
                ) {
                  return false;
                }

                return true;
              }
            )
            .nullable(),
          quantity: Yup.number()
            .test(
              "validate-quantity",
              "Tổng số lần điều trị phải lớn hơn tổng số lượt đã điều trị",
              function (value) {
                const { totalPerformedTimes, service } = this.parent;
                const totalTimes = value * (service?.treatmentTimes || 1);
                if (totalPerformedTimes) {
                  if (totalTimes < (totalPerformedTimes || 1)) return false;
                }
                return true;
              }
            )
            .nullable(),
          oldCredit: Yup.number()
            .test(
              "validate-oldCredit",
              "Tiền khấu trừ dịch vụ phải nhỏ hơn thành tiền dịch vụ",
              function (value) {
                const { amount } = this.parent;
                if (amount < value) {
                  return false;
                }
                return true;
              }
            )
            .test(
              "validate-oldCredit-positive ",
              "Tiền khấu trừ > 0",
              function (value) {
                if (value < 0) {
                  return false;
                }
                return true;
              }
            )
            .nullable(),

          // ✅ Thêm validate bảo hành
          warrantyTotalTimes: Yup.number().when("hasWarranty", {
            is: true,
            then: Yup.number()
              .required("Vui lòng nhập số lần bảo hành!")
              .min(1, "Số lần bảo hành phải lớn hơn 0!"),
            otherwise: Yup.number().nullable(),
          }),

          hasWarranty: Yup.boolean().nullable(),
          ...(REQUIRED_CTKM
            ? {
              promotionProgram: Yup.object()
                .nullable()
                .required("Chưa chọn CTKM!"),
            }
            : {}),
          service: Yup.object()
            .nullable()
            .required("Chưa chọn dịch vụ!")
            .test(
              "service-belong-department",
              "Dịch vụ không thuộc cơ sở đăng ký",
              function (service) {
                const department = this.options.context?.department;

                if (!service || !department) return true;

                const serviceDepartments = service?.serviceDepartments || [];

                // Không cấu hình cơ sở → pass
                if (serviceDepartments.length === 0) return true;

                // Có ít nhất 1 cơ sở trùng
                return serviceDepartments.some(
                  (sd) => sd?.department?.id === department?.id
                );
              }
            ),
        })
      )
      .nullable(),

    drugs: Yup.array()
      .of(
        Yup.object().shape({
          ...(REQUIRED_CTKM
            ? {
              promotionProgram: Yup.object()
                .nullable()
                .required("Chưa chọn CTKM!"),
            }
            : {}),
          price: Yup.number().min(0, "Giá phải lớn hơn 0!").nullable(),
          percentDiscount: Yup.number()
            .max(100, "Giảm giá phải nhỏ hơn 100!")
            .test(
              "validate-percentDiscount",
              "Không được quá % giảm giá của chương trình khuyến mãi này",
              function (value) {
                const { promotionProgram } = this.parent;

                // 👉 CHỈ validate khi có promotionProgram
                if (!promotionProgram) return true;

                // Nếu không thuộc nhóm code cần validate → bỏ qua
                if (!PROMOTION_CODES?.includes(promotionProgram?.code)) return true;

                if (
                  promotionProgram.allProductMaxDiscountPercent != null &&
                  value > promotionProgram.allProductMaxDiscountPercent
                ) {
                  return false;
                }

                if (
                  promotionProgram.products?.length > 0 &&
                  value > promotionProgram.products[0]?.maxDiscountPercent
                ) {
                  return false;
                }

                return true;
              }
            )
            .nullable(),
          discount: Yup.number().min(0, "Giảm giá phải lớn hơn 0!").nullable(),
          oldCredit: Yup.number()
            .test(
              "validate-oldCredit",
              "Tiền khấu trừ sản phẩm phải nhỏ hơn thành tiền sản phẩm",
              function (value) {
                const { amount } = this.parent;
                if (amount < value) {
                  return false;
                }
                return true;
              }
            )
            .test(
              "validate-oldCredit-positive ",
              "Tiền khấu trừ > 0",
              function (value) {
                if (value < 0) {
                  return false;
                }
                return true;
              }
            )
            .nullable(),
          amount: Yup.number()
            .typeError("Thành tiền phải là số")

            .test(
              "validate-amount",
              "Không được bán dưới mức giá tối thiểu",
              function (amount) {
                const { soldQuantity, drug } = this.parent;
                if (!soldQuantity || !drug?.minSellingPrice || !amount) {
                  return true;
                } else {
                  let minSellingPriceVal = amount / soldQuantity;
                  if (minSellingPriceVal < drug?.minSellingPrice) {
                    return false;
                  }
                  return true;
                }
              }
            )
            .nullable(),
        })
      )
      .nullable(),
  });

  const source = initialPatient?.patientInfo?.currentPatientSource;

  return (
    <>
      <PopupForm
        open={open}
        size="xl"
        handleClose={handleClose}
        title={`${initRegisterTreatmentPlan?.id ? "Chỉnh sửa" : "Thêm"
          }  liệu trình`}
        formik={{
          initialValues: {
            ...initRegisterTreatmentPlan,
            department: initRegisterTreatmentPlan?.id
              ? initRegisterTreatmentPlan?.department
              : department,
            sourceRevenue: source,
            customerSourceWalkIn,
            patient: initialPatient?.patientInfo,
            listCodeSource: listCodeSource,
          },
          validationSchema: validationSchema,
          onSubmit: async (values, actions) => {
            const service = values?.paServiceRegister?.length > 0;
            const drug = values?.drugs?.length > 0;
            if (!service && !drug) {
              toast.error("Vui lòng chọn ít nhất một dịch vụ hoặc sản phẩm!");
              actions.setSubmitting(false);
              return;
            }
            const data = await onSubmit(values, actions);
            if (handleAfterSubmit && data?.responseStatus !== false) {
              handleAfterSubmit();
            }
          },
          enableReinitialize: true,
        }}
        action={({ isSubmitting, values, setFieldValue, submitForm }) => {
          return (
            <div className="flex-center gap-1">
              {initRegisterTreatmentPlan?.cardStatus ===
                STATUS_TREATMENT_LOCK && (
                  <>
                    <PaymentVoucherButton
                      isMobile={isMobile}
                      patient={initialPatient?.patientInfo}
                      treatmentPlanCard={{ id: values?.id }}
                      listPaymentMethod={listPaymentMethod}
                      listStk={listStk}
                      remainingAmount={values?.remainingAmount}
                      customerSourceWalkIn={customerSourceWalkIn}
                      department={values?.department}
                    />
                  </>
                )}
              {initRegisterTreatmentPlan?.cardStatus !==
                STATUS_TREATMENT_LOCK &&
                !initRegisterTreatmentPlan?.id && (
                  <CommonButton
                    className="btn-primary"
                    disabled={isSubmitting}
                    onClick={async () => {
                      await setFieldValue("isContinue", true);
                      await submitForm();
                    }}
                  >
                    {!isMobile && <Save className="mr-2 " />}
                    {`${"Thêm và kê tiếp"}  liệu trình`}
                  </CommonButton>
                )}

              <CommonButton
                type="submit"
                className="btn-primary"
                disabled={isSubmitting}
              >
                {!isMobile && <Save className="mr-2 " />}
                {`${initRegisterTreatmentPlan?.id ? "Chỉnh sửa" : "Thêm"
                  }  liệu trình`}
              </CommonButton>

              <CommonButton className="btn-gray" onClick={handleClose}>
                <Block className="mr-2" /> Đóng
              </CommonButton>
            </div>
          );
        }}
      >
        {({ setFieldValue, values }) => {
          return (
            <>
              <ValueForm
                listVatPercent={listVatPercent}
                patient={initialPatient?.patientInfo}
                customerSourceWalkIn={customerSourceWalkIn}
                departmentsUser={departmentsUser}
                handleGetListCodeSource={handleGetListCodeSource}
                initRegisterTreatmentPlan={initRegisterTreatmentPlan}
              />
              <DialogError
                patient={initialPatient?.patientInfo}
                setFieldValue={setFieldValue}
                values={values}
              />
            </>
          );
        }}
      </PopupForm>
    </>
  );
};

const ValueForm = observer(
  ({
    listVatPercent,
    patient,
    customerSourceWalkIn,
    departmentsUser,
    handleGetListCodeSource,
    initRegisterTreatmentPlan,
  }) => {
    const { setFieldValue, values } = useFormikContext();
    const { defaultFreePromotion } = useStore().feeStore.serviceFeeTabStore;
    let isAdminPermission = isAdmin();
    let isPaymentPermission = isRoleHisPayment();
    let currentConsultant = patient?.currentConsultant;
    let currentTelesale = patient?.currentTelesale;
    let totalAmountRevenues = 0;
    const hasPaidStatus = (list) =>
      list?.some((item) =>
        [INVOICE_PAID, INVOICE_PARTIAL_PAID].includes(item?.paymentStatus)
      );

    const isDisabled =
      hasPaidStatus(values?.paServiceRegister) || hasPaidStatus(values?.drugs);

    totalAmountRevenues =
      +values?.totalAmount -
      (+values?.discount || 0) +
      (+values?.taxTotal || 0);
    // (values?.oldCredit || values?.oldTreatmentCredit);

    const handleAddProductAndService = () => {
      let feeItemSerive;
      let feeItemDrug;
      let totalAmountDrugs = 0;
      let totalAmountServices = 0;
      let newpaServiceRegister = [];
      let newDrugs = [];
      let taxTotalDrugVatInclude = 0;
      let taxTotalDrug = 0;
      let taxTotalServiceVatInclude = 0;
      let taxTotalService = 0;

      if (values?.servicePush) {
        const usingServiceFees =
          values?.servicePush?.serviceFeeList?.filter((f) => f?.isUsing) || [];
        console.log(
          "🚀 ~ handleAddProductAndService ~ usingServiceFees:",
          usingServiceFees
        );
        feeItemSerive =
          usingServiceFees?.length > 0
            ? getPriceTypeService(
              getIn(values, "patientTypeService"),
              usingServiceFees || []
            )
            : null;

        let taxPercent = feeItemSerive?.serviceVAT?.vatPercent?.toString() || 0;

        if (feeItemSerive?.vatIncluded) {
          taxTotalServiceVatInclude =
            ((feeItemSerive?.price * 1) / (+taxPercent + 100)) * +taxPercent;
        } else {
          taxTotalService =
            feeItemSerive?.price * 1 * ((+taxPercent || 0) / 100);
        }

        let warrantyInfo = {};

        if (DEFAULT_GET_WARRANTY) {
          warrantyInfo = handleDefaultServiceWarranty(
            values?.servicePush,
            feeItemSerive
          );
        }

        let newService = {
          service: values?.servicePush,
          name: values?.servicePush?.tradeName || values?.servicePush?.name,
          quantity: 1,
          currentEdit: true,
          price: feeItemSerive?.price ? +feeItemSerive?.price : 0,
          amount: feeItemSerive?.price ? +feeItemSerive?.price : 0,
          isEditable: true,
          fees: usingServiceFees?.map((el) => ({
            ...el?.patientTypeService,
            price: el?.price,
            vatIncluded: el?.vatIncluded,
            serviceVAT: el?.serviceVAT,
            patientTypeService: el?.patientTypeService,
          })),
          patientTypeService: {
            ...feeItemSerive,
            name: feeItemSerive?.patientTypeService?.name,
            code: feeItemSerive?.patientTypeService?.code,
            id: feeItemSerive?.patientTypeService?.id,
          },
          priceWithTax: feeItemSerive?.vatIncluded,
          taxTotal: taxTotalService + taxTotalServiceVatInclude,
          taxPercent,
          // promotionProgram: defaultFreePromotion,
          ...warrantyInfo,
          totalVolumeSold:
            values?.servicePush?.serviceTreatmentType ===
              SERVICE_TREATMENT_TYPE_TREATMENT_BY_VOLUME
              ? values?.servicePush?.volumePerService
                ? values?.servicePush?.volumePerService
                : 0
              : null,
        };
        newpaServiceRegister = [
          ...(values?.paServiceRegister || []),
          { ...newService },
        ];

        totalAmountServices = newpaServiceRegister?.reduce((acc, curr) => {
          return acc + (curr?.quantity || 1) * curr?.price;
        }, 0);
        setFieldValue("paServiceRegister", newpaServiceRegister);
      }

      if (values?.drugPush) {
        const usingDrugFees =
          values?.drugPush?.drugUnitPrices?.filter((f) => f?.isUse) || [];
        console.log(
          "🚀 ~ handleAddProductAndService ~ usingDrugFees:",
          usingDrugFees
        );
        feeItemDrug =
          usingDrugFees?.length > 0
            ? getPriceTypeService(
              getIn(values, "patientTypeService"),
              usingDrugFees || []
            )
            : null;

        let taxPercent = feeItemDrug?.serviceVAT?.vatPercent?.toString() || 0;

        if (feeItemDrug?.isTaxIncluded) {
          taxTotalDrugVatInclude =
            ((feeItemDrug?.price * 1) / (+taxPercent + 100)) * +taxPercent;
        } else {
          taxTotalDrug = feeItemDrug?.price * 1 * ((+taxPercent || 0) / 100);
        }
        let newDrug = {
          drug: values?.drugPush,
          name: values?.drugPush?.tradeName || values?.drugPush?.name,
          soldQuantity: 1,
          currentEdit: true,
          price: feeItemDrug?.price ? +feeItemDrug?.price : 0,
          amount: feeItemDrug?.price ? +feeItemDrug?.price : 0,

          isEditable: true,
          fees: usingDrugFees?.map((el) => ({
            ...el?.patientTypeService,
            price: el?.price,
            vatIncluded: el?.isTaxIncluded,
            serviceVAT: el?.serviceVAT,
            patientTypeService: el?.patientTypeService,
          })),
          patientTypeService: {
            ...feeItemDrug,
            name: feeItemDrug?.patientTypeService?.name,
            code: feeItemDrug?.patientTypeService?.code,
            id: feeItemDrug?.patientTypeService?.id,
          },
          priceWithTax: feeItemDrug?.isTaxIncluded,
          taxTotal: +taxTotalDrug + +taxTotalDrugVatInclude,
          taxPercent,
          // promotionProgram: defaultFreePromotion,
        };
        newDrugs = [...(values?.drugs || []), { ...newDrug }];

        totalAmountDrugs = newDrugs?.reduce((acc, curr) => {
          return acc + (curr?.quantity || 1) * curr?.price;
        }, 0);
        setFieldValue("drugs", newDrugs);
      }
      //  set lại tiền thuế
      setFieldValue(
        "taxTotal",
        (+values?.taxTotal || 0) + taxTotalDrug + taxTotalService
      );

      //TH ko lấy giá tổng
      if (!values?.isTotalPriceUsed) {
        setFieldValue(
          "totalAmount",
          (+values?.totalAmount || 0) +
          (+feeItemSerive?.price || 0) +
          (+feeItemDrug?.price || 0)
        );
      } else {
        const totalAmountItem = +totalAmountServices + +totalAmountDrugs;
        if (values?.totalAmount < totalAmountItem) {
          const percentAllocateItem =
            (totalAmountItem - values?.totalAmount) / totalAmountItem;
          const formatDataService = newpaServiceRegister?.map((el, ind) => ({
            ...el,
            percentDiscount: percentAllocateItem,
            discount:
              percentAllocateItem *
              el?.price *
              (el?.unLimited ? 1 : el?.quantity),
          }));

          const formatDataDrugs = newDrugs?.map((el, ind) => ({
            ...el,
            percentDiscount: percentAllocateItem,
            discount:
              percentAllocateItem *
              el?.price *
              (el?.unLimited ? 1 : el?.soldQuantity),
          }));

          setFieldValue(`paServiceRegister`, formatDataService);
          setFieldValue(`drugs`, formatDataDrugs);
        }
      }

      setFieldValue("servicePush", null);
      setFieldValue("drugPush", null);
    };

    const handleOnChangeTreatment = (value) => {
      setFieldValue("clientCard", value);
      setFieldValue("name", value?.tradeName || value?.name);
      setFieldValue("isTotalPriceUsed", value?.isTotalPriceUsed);

      let feeItem;
      let price;
      let totalAmount;
      let totalDiscount = 0;
      let totalAmountServices = 0;
      let totalAmountDrugs = 0;
      feeItem =
        value?.clientCardFees?.length > 0
          ? getPriceTypeService(
            getIn(values, "patientTypeService"),
            value?.clientCardFees || [],
            values?.quantity || 1
          )
          : null;

      if (value?.services && value?.services?.length > 0) {
        totalAmountServices = value?.services?.reduce((acc, curr) => {
          return acc + (curr?.quantity || 1) * curr?.netPrice;
        }, 0);
      }
      if (value?.products && value?.products?.length > 0) {
        totalAmountDrugs = value?.products?.reduce((acc, curr) => {
          return acc + (curr?.quantity || 1) * curr?.netPrice;
        }, 0);
      }

      if (value?.isTotalPriceUsed) {
        //nếu lấy giá tổng thì lấy theo loại giá
        price = feeItem?.price || value?.totalNetPrice;
        totalAmount = price * values?.quantity;
      } else {
        totalAmount = price = totalAmountServices + +totalAmountDrugs;
      }

      if (
        (value?.services && value?.services?.length > 0) ||
        (value?.products && value?.products?.length > 0)
      ) {
        let formatDataService;
        let formatDataDrug;
        // lấy theo giá tổng // logic giá tổng = tổng giá thành phần ,nếu ko = thì phân bổ tiền sang giảm giá

        if (value?.isTotalPriceUsed) {
          const totalAmountItem = +totalAmountServices + +totalAmountDrugs;
          if (totalAmount < totalAmountItem) {
            const percentAllocateItem =
              (totalAmountItem - totalAmount) / totalAmountItem;
            formatDataService = value?.services?.map((el) => {
              const feeSv =
                el?.fees?.length > 0
                  ? getPriceTypeService(el?.patientTypeService, el?.fees || [], el?.quantity)
                  : null;

              let taxTotal = 0;
              let taxPercent = feeSv?.serviceVAT?.vatPercent?.toString() || 0;

              if (feeSv?.vatIncluded) {
                taxTotal =
                  ((feeSv?.price * el?.quantity - (el?.discount || 0)) /
                    (+taxPercent + 100)) *
                  +taxPercent;
              } else {
                taxTotal =
                  (feeSv?.price * el?.quantity - (el?.discount || 0)) *
                  ((+taxPercent || 0) / 100);
              }

              return {
                service: el?.service,
                name: el?.service?.tradeName || el?.service?.name,
                amount: feeSv?.price * el?.unLimited ? 1 : el?.quantity,
                quantity: el?.unLimited ? 1 : el?.quantity,
                note: "",
                unLimited: el?.unLimited,
                price: feeSv?.price,
                percentDiscount: percentAllocateItem,
                discount:
                  percentAllocateItem *
                  feeSv?.price *
                  (el?.unLimited ? 1 : el?.quantity),
                isEditable: el?.isEditable,
                taxPercent,
                taxTotal,
                priceWithTax: feeSv?.vatIncluded,
                fees: el?.fees?.map((el) => ({
                  ...el?.patientTypeService,

                  price: el?.price,
                  vatIncluded: el?.vatIncluded,
                  serviceVAT: el?.serviceVAT,
                  patientTypeService: el?.patientTypeService,
                })),
                patientTypeService: {
                  ...feeSv,
                  id: feeSv?.patientTypeService?.id,
                },
              };
            });

            formatDataDrug = value?.products?.map((el) => ({
              amount: el?.netPrice * el?.unLimited ? 1 : el?.quantity,
              drug: el?.drug,
              name: el?.drug?.tradeName || el?.drug?.name,
              soldQuantity: el?.unLimited ? 1 : el?.quantity,
              price: el?.netPrice,
              percentDiscount: percentAllocateItem,
              discount:
                percentAllocateItem *
                el?.netPrice *
                (el?.unLimited ? 1 : el?.quantity),
              isEditable: el?.isEditable,
            }));

            setFieldValue("discount", totalAmountItem - totalAmount);
          }
        } else {
          formatDataService = value?.services?.map((el) => {
            const feeSv =
              el?.fees?.length > 0
                ? getPriceTypeService(el?.patientTypeService, el?.fees || [], el?.quantity)
                : null;
            let taxTotal = 0;
            let taxPercent = feeSv?.serviceVAT?.vatPercent?.toString() || 0;

            if (feeSv?.vatIncluded) {
              taxTotal =
                ((feeSv?.price * el?.quantity - (el?.discount || 0)) /
                  (+taxPercent + 100)) *
                +taxPercent;
            } else {
              taxTotal =
                (feeSv?.price * el?.quantity - (el?.discount || 0)) *
                ((+taxPercent || 0) / 100);
            }
            const quantity = el?.unLimited ? 1 : el?.quantity;
            totalDiscount += feeSv?.discount * quantity;

            return {
              service: el?.service,
              name: el?.service?.tradeName || el?.service?.name,
              amount: quantity * (feeSv?.price - (feeSv?.discount || 0)),
              quantity,
              note: "",
              unLimited: el?.unLimited,
              price: feeSv?.price || 0,
              discount: feeSv?.discount * quantity,
              percentDiscount: feeSv?.percentDiscount,
              isEditable: el?.isEditable,
              taxPercent,
              taxTotal,
              priceWithTax: feeSv?.vatIncluded,
              fees: el?.fees?.map((el) => ({
                ...el?.patientTypeService,

                price: el?.price,
                vatIncluded: el?.vatIncluded,
                serviceVAT: el?.serviceVAT,
                patientTypeService: el?.patientTypeService,
              })),
              patientTypeService: {
                ...feeSv,
                id: feeSv?.patientTypeService?.id,
              },
            };
          });

          formatDataDrug = value?.products?.map((el) => {
            const feeSv =
              el?.fees?.length > 0
                ? getPriceTypeService(el?.patientTypeService, el?.fees || [], el?.quantity)
                : null;
            let taxTotal = 0;
            let taxPercent = feeSv?.serviceVAT?.vatPercent?.toString() || 0;

            if (feeSv?.vatIncluded) {
              taxTotal =
                ((feeSv?.price * el?.quantity - (el?.discount || 0)) /
                  (+taxPercent + 100)) *
                +taxPercent;
            } else {
              taxTotal =
                (feeSv?.price * el?.quantity - (el?.discount || 0)) *
                ((+taxPercent || 0) / 100);
            }
            const soldQuantity = el?.unLimited ? 1 : el?.quantity;
            totalDiscount += feeSv?.discount * soldQuantity;

            return {
              drug: el?.drug,
              name: el?.drug?.tradeName || el?.drug?.name,
              amount: soldQuantity * (feeSv?.price - (feeSv?.discount || 0)),
              soldQuantity,
              price: feeSv?.price,
              discount: feeSv?.discount * soldQuantity,

              percentDiscount: feeSv?.percentDiscount,
              note: "",
              unLimited: el?.unLimited,
              isEditable: el?.isEditable,
              priceWithTax: feeSv?.vatIncluded,
              taxPercent,
              taxTotal,
              fees: el?.fees?.map((el) => ({
                ...el?.patientTypeService,

                price: el?.price,
                vatIncluded: el?.vatIncluded,
                serviceVAT: el?.serviceVAT,
                patientTypeService: el?.patientTypeService,
              })),
              patientTypeService: {
                ...feeSv,
                id: feeSv?.patientTypeService?.id,
              },
            };
          });
        }
        setFieldValue("paServiceRegister", formatDataService);
        setFieldValue("drugs", formatDataDrug);
      } else {
        setFieldValue("paServiceRegister", []);
        setFieldValue("drugs", []);
      }

      let revenueAllocations = value?.revenueAllocations || [];
      if (revenueAllocations) {
        let staffRevenues = revenueAllocations?.map((el) => ({
          position: el?.position,
          percentRevenue: el?.commissionRate,
          source: patient?.currentPatientSource
            ? patient?.currentPatientSource
            : customerSourceWalkIn,
          staff:
            currentConsultant?.position?.code === el?.position?.code
              ? currentConsultant
              : currentTelesale?.position?.code === el?.position?.code
                ? currentTelesale
                : null,
        }));
        setFieldValue("staffRevenues", staffRevenues);
      }

      setFieldValue("price", price);
      setFieldValue("totalAmount", totalAmount);
      setFieldValue("discount", totalDiscount);
      setFieldValue("patientTypeService", {
        ...feeItem?.patientTypeService,
        price: feeItem?.price,
      });
    };

    const handleOnChangePatientTypeService = (value) => {
      setFieldValue("patientTypeService", value);
      if (value?.isTotalPriceUsed) {
      } else {
        setFieldValue("price", value?.price);
      }
    };

    const handleOnChangePrice = (e) => {
      let price = +e?.target?.value;
      let totalAmount = values?.quantity * price;
      setFieldValue("price", price);
      setFieldValue("totalAmount", totalAmount);
    };

    const handleOnChangeTotalAmount = (e) => {
      let totalAmount = e.target.value;
      setFieldValue("totalAmount", totalAmount);
      setFieldValue("price", totalAmount / (values?.quantity || 1));
    };

    const handleChangeEndDate = (date) => {
      setFieldValue("endDate", date);

      values?.paServiceRegister?.forEach((item, index) => {
        if (!item?.unLimited) {
          setFieldValue(`paServiceRegister[${index}].expiryDate`, date);
        }
      });

      values?.drugs?.forEach((item, index) => {
        if (!item?.unLimited) {
          setFieldValue(`drugs[${index}].expiryDate`, date);
        }
      });
    };

    const handleOnChangeDiscount = (discount) => {
      setFieldValue("discount", discount);
      let formatDataService;
      let formatDataDrug;

      const percentAllocateItem = discount / values?.totalAmount;
      formatDataService = values?.paServiceRegister?.map((el) => {
        return {
          ...el,
          percentDiscount: percentAllocateItem * 100,
          discount:
            percentAllocateItem *
            el?.price *
            (el?.unLimited ? 1 : el?.quantity),
        };
      });

      formatDataDrug = values?.drugs?.map((el) => ({
        ...el,
        percentDiscount: percentAllocateItem * 100,
        discount:
          percentAllocateItem *
          el?.price *
          (el?.unLimited ? 1 : el?.soldQuantity),
      }));

      setFieldValue("paServiceRegister", formatDataService);
      setFieldValue("drugs", formatDataDrug);
    };
    const { openDepositDeductionPopup } =
      useStore().patientManagementStore.voucherDepositDeductionStore;
    const [checkedState, setCheckedState] = useState(false);
    // Có dữ liệu cấn trừ hay không
    const hasData =
      (values?.voucherAllocations?.length || 0) > 0 ||
      (values?.invoiceItemAllocations?.length || 0) > 0;
    // Đang chỉnh sửa
    const isEdit = Boolean(initRegisterTreatmentPlan?.id);
    // Checkbox hiển thị
    const checked = checkedState || hasData;
    // Disable CHỈ khi edit
    const disabled = isEdit && hasData;
    return (
      <>
        {/* <FormikFocusError /> */}
        <Grid container spacing={1}>
          <Grid item xs={12} md={9}>
            <div className="sv-section-title">🔁 Thông tin đăng ký</div>
            <div className="new-product-section">
              {values?.oldTreatmentPlanCard && (
                <Grid
                  container
                  spacing={1}
                  style={{ backgroundColor: "aliceblue", marginBottom: "8px" }}
                >
                  <Grid item xs={12} sm={12} md={12}>
                    <OldTreatment />
                  </Grid>
                </Grid>
              )}

              <Grid container spacing={1}>
                <Grid item xs={12} sm={6} md={2}>
                  <GlobitsPagingAutocomplete
                    api={
                      isAdminPermission
                        ? pagingDepartment
                        : async () => ({
                          data: {
                            content: departmentsUser || [],
                            totalElements: departmentsUser?.length || 0,
                            totalPages: 1,
                          },
                        })
                    }
                    name={"department"}
                    label="Cơ sở"
                    disabled={isDisabled}
                    onChange={(_, value) => {
                      setFieldValue("department", value);
                      const searchCodeSource = {
                        level: LEAD_SOURCE_LEVEL.LEVEL_2.value,
                        startDate: values?.startDate,
                        patientId: values?.patient?.id,
                        departmentId: value?.id,
                        voucherIds: Array.isArray(values?.voucherAllocations)
                          ? values.voucherAllocations
                            .map((item) => item?.voucher?.id)
                            .filter(Boolean)
                          : [],

                        invoiceItemIds: Array.isArray(
                          values?.invoiceItemAllocations
                        )
                          ? values.invoiceItemAllocations
                            .map((item) => item?.invoiceItem?.id)
                            .filter(Boolean)
                          : [],
                      };

                      handleGetListCodeSource(searchCodeSource, setFieldValue);
                    }}
                    required
                  />
                </Grid>
                <Grid item xs={6} sm={6} md={2}>
                  <GlobitsDateTimePicker
                    name={"startDate"}
                    label="Ngày đăng ký"
                    disabled={isDisabled}
                    maxDateMessage="Ngày đăng ký phải trước ngày hiện tại"
                    maxDate={new Date()}
                    isDateTimePicker
                    onChange={(value) => {
                      setFieldValue("startDate", value);
                      if (!value) return;
                      const searchCodeSource = {
                        level: LEAD_SOURCE_LEVEL.LEVEL_2.value,
                        startDate: value,
                        patientId: values?.patient?.id,
                        departmentId: values?.department?.id,
                        voucherIds: Array.isArray(values?.voucherAllocations)
                          ? values.voucherAllocations
                            .map((item) => item?.voucher?.id)
                            .filter(Boolean)
                          : [],

                        invoiceItemIds: Array.isArray(
                          values?.invoiceItemAllocations
                        )
                          ? values.invoiceItemAllocations
                            .map((item) => item?.invoiceItem?.id)
                            .filter(Boolean)
                          : [],
                      };
                      handleGetListCodeSource(searchCodeSource, setFieldValue);
                    }}
                  />
                </Grid>
                <Grid item xs={6} sm={6} md={2}>
                  <GlobitsDateTimePicker
                    name={"endDate"}
                    label="Ngày hết hạn sử dụng"
                    disabled={isDisabled}
                    isDateTimePicker
                    onChange={(date) => handleChangeEndDate(date)}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <GlobitsPagingAutocomplete
                    api={pagingClientCard}
                    name={"clientCard"}
                    label="Liệu trình"
                    disabled={isDisabled}
                    filterOptions={(options, state) =>
                      options.filter(
                        (option) =>
                          option?.name
                            ?.toLowerCase()
                            .includes(state?.inputValue?.toLowerCase()) ||
                          option?.code
                            ?.toLowerCase()
                            .includes(state?.inputValue?.toLowerCase())
                      )
                    }
                    searchObject={{
                      type: TYPE_CARD[1].value,
                      isUsing: true,
                      isApply: true,
                    }}
                    onChange={(_, value) => {
                      handleOnChangeTreatment(value);
                    }}
                    ListboxComponent={forwardRef((props, ref) => {
                      const { children, ...other } = props;
                      return (
                        <ul {...other} ref={ref}>
                          <ol>
                            <li>{children}</li>
                          </ol>
                        </ul>
                      );
                    })}
                    renderOption={(option) => renderOptionsTrement(option)}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <GlobitsTextField
                    name={"name"}
                    label="Tên liệu trình đăng ký"
                  // disabled={isDisabled}
                  />
                </Grid>
                <Grid item xs={6} sm={6} md={2}>
                  <GlobitsAutocomplete
                    label={"Loại giá"}
                    disabled={isDisabled}
                    options={values?.clientCard?.clientCardFees?.map(
                      (item) => ({
                        ...item?.patientTypeService,

                        price: item?.price,
                        vatIncluded: item?.vatIncluded,
                        serviceVAT: item?.serviceVAT,
                      })
                    )}
                    onChange={(_, value) => {
                      handleOnChangePatientTypeService(value);
                    }}
                    name={"patientTypeService"}
                    getOptionLabel={(option) => {
                      return option?.name ? `${option.name} ` : "";
                    }}
                  />
                </Grid>

                <Grid item xs={6} sm={6} md={2}>
                  <GlobitsVNDCurrencyInputOnlyChange
                    isOnlyOnChange
                    label={"Giá"}
                    name={"price"}
                    disabled={
                      (PERMISSION_ROLE_HIS_PAYMENT && !isPaymentPermission) ||
                      isDisabled
                    }
                    onChange={handleOnChangePrice}
                  />
                </Grid>
                <Grid item xs={6} sm={6} md={2}>
                  <GlobitsVNDCurrencyInput
                    label={"Thành tiền"}
                    name={"totalAmount"}
                    onChange={handleOnChangeTotalAmount}
                    disabled
                  />
                </Grid>

                <Grid item xs={6} sm={6} md={2}>
                  <GlobitsVNDCurrencyInputOnlyChange
                    isOnlyOnChange
                    label={"Số tiền giảm"}
                    name={"discount"}
                    disabled={isDisabled}
                    onChange={(e) => {
                      let discount = +e?.target.value;
                      handleOnChangeDiscount(discount);
                    }}
                  />
                </Grid>

                <Grid item xs={6} sm={6} md={2}>
                  <GlobitsVNDCurrencyInput
                    label={"Tiền Vat"}
                    name={`taxTotal`}
                    disabled
                  />
                </Grid>

                <Grid item xs={6} sm={6} md={2}>
                  <GlobitsTextField
                    label={"Mã giảm giá"}
                    disabled={isDisabled}
                    name={"marketingVoucherCode"}
                  />
                </Grid>

                <Grid item xs={6} sm={6} md={2} container alignItems="center">
                  <GlobitsCheckBox
                    label={"Lấy theo giá tổng"}
                    name={"isTotalPriceUsed"}
                    disabled
                  />
                </Grid>

                <Grid item xs={6} sm={6} md={3} container alignItems="center">
                  <GlobitsCheckBox
                    label="Cấn trừ từ đơn hàng/tiền cọc"
                    checked={checked}
                    disabled={disabled}
                    onChange={(e) => {
                      const value = e.target.checked;
                      setCheckedState(value);
                      if (!value && !isEdit) {
                        setFieldValue("voucherAllocations", []);
                        setFieldValue("invoiceItemAllocations", []);
                      }
                    }}
                  />
                </Grid>

                <Grid item xs={12} sm={6} md={3}>
                  <GlobitsTextField
                    label={"Ghi chú"}
                    name={"note"}
                    isTextArea
                  />
                </Grid>
              </Grid>
            </div>
          </Grid>

          <Grid item xs={12} md={3}>
            {/* Tổng thanh toán */}
            <RowTotalTreatmentPlan data={values} />
          </Grid>
          {/* Danh sách trừ tiền cọc và đơn hàng */}
          {checked && (
            <Grid item xs={12} md={12}>
              <DeductionList
                initRegisterTreatmentPlan={initRegisterTreatmentPlan}
              />
            </Grid>
          )}
          <Grid item xs={12} md={12}>
            <span class="symbol sv-section-title">⏳ Phân bổ</span>
            <div className="new-product-section">
              <Grid container spacing={1}>
                {/* Phẩn bổ doanh thu */}
                <RegisterServiceStaffsRevenue
                  totalAmount={totalAmountRevenues}
                  popupType={POPUP_TYPE_REGISTER_TREATMENT}
                />
              </Grid>
            </div>
          </Grid>

          {(values?.paServiceRegister || values?.clientCard?.isEditable) && (
            <Grid item xs={12} md={12}>
              <span class="symbol sv-section-title">📊 Thông tin dịch vụ</span>

              <div className="new-product-section">
                <Grid container spacing={1}>
                  <Grid item xs={12} sm={6} md={2}>
                    <p className="table-section-title">
                      Danh sách dịch vụ/sản phẩm
                    </p>
                  </Grid>
                  {values?.clientCard?.isEditable && (
                    <>
                      <Grid item xs={12} sm={6} md={3}>
                        <GlobitsPagingAutocomplete
                          disableClearable
                          label={"Chọn dịch vụ"}
                          name={"servicePush"}
                          api={pagingHealthCareService}
                          searchObject={{
                            isApply: true,
                            isUse: true,
                            serviceGroupIds:
                              values?.clientCard?.serviceGroups?.map(
                                (item) => item?.serviceGroup?.id
                              ) || [],
                            departmentId: values?.department?.id,
                          }}
                          ListboxComponent={forwardRef((props, ref) => {
                            const { children, ...other } = props;
                            return (
                              <ul {...other} ref={ref}>
                                <ol>
                                  <li>{children}</li>
                                </ol>
                              </ul>
                            );
                          })}
                          renderOption={(option) =>
                            renderOptionsService(option)
                          }
                          onChange={(_, value) => {
                            setFieldValue("servicePush", value);
                          }}
                          filterOptions={filterBaseOptions}
                          onKeyDown={(e) => {
                            if (e.key === "Enter") {
                              e.preventDefault();
                              setTimeout(() => {
                                const val = values?.servicePush;
                                if (val) {
                                  handleAddProductAndService();
                                }
                              }, 0);
                            }
                          }}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6} md={3}>
                        <GlobitsPagingAutocomplete
                          disableClearable
                          label={"Sản phẩm"}
                          api={pagingDrug}
                          filterOptions={filterBaseOptions}
                          searchObject={{
                            abstractProductIds:
                              values?.clientCard?.abstractProducts?.map(
                                (item) => item?.abstractProduct?.id
                              ) || [],
                            isUsing: true,
                            isApply: true,
                          }}
                          name={"drugPush"}
                          ListboxComponent={forwardRef((props, ref) => {
                            const { children, ...other } = props;
                            return (
                              <ul {...other} ref={ref}>
                                <ol>
                                  <li>{children}</li>
                                </ol>
                              </ul>
                            );
                          })}
                          renderOption={(option) => renderOptionsDrug(option)}
                          onChange={(_, value) => {
                            setFieldValue("drugPush", value);
                          }}
                          onKeyDown={(e) => {
                            if (e.key === "Enter") {
                              e.preventDefault();
                              setTimeout(() => {
                                const val = values?.drugPush;
                                if (val) {
                                  handleAddProductAndService();
                                }
                              }, 0);
                            }
                          }}
                        />
                      </Grid>

                      <Grid
                        item
                        xs={12}
                        md={4}
                        className="flex align-end justify-between"
                      >
                        <CommonButton onClick={handleAddProductAndService}>
                          <ArrowDownward />
                        </CommonButton>
                        {!isDisabled && (
                          <PromotionProgram
                            setFieldValue={setFieldValue}
                            initialValues={values}
                          />
                        )}
                      </Grid>
                    </>
                  )}

                  {values?.selectedVoucher && (
                    <Grid item xs={12}>
                      <div
                        style={{
                          color: "#1976d2",
                          fontStyle: "italic",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "flex-end",
                        }}
                      >
                        <span
                          style={{ fontWeight: 500 }}
                          className="flex align-center gap-1"
                        >
                          {!isDisabled && (
                            <ButtonDeleteProgram
                              setFieldValue={setFieldValue}
                              values={values}
                            />
                          )}
                          Chương trình khuyến mãi đã chọn:
                        </span>
                        <span style={{ marginLeft: 4 }}>
                          {values?.selectedVoucher?.name}
                        </span>
                      </div>
                    </Grid>
                  )}

                  <Grid item xs={12}>
                    <PaServiceRegisterTable
                      disabled={isDisabled}
                      listVatPercent={listVatPercent}
                      discountPercent={values?.discountPercent}
                      selectedVoucher={values?.selectedVoucher}
                      paServiceRegister={values?.paServiceRegister}
                      drugs={values?.drugs}
                    />
                  </Grid>
                  <DialogErrorMessage />
                </Grid>
              </div>
            </Grid>
          )}
        </Grid>
      </>
    );
  }
);

const OldTreatment = observer(() => {
  const { values } = useFormikContext();
  const serviceCount =
    Math.min(values?.oldTreatmentPlanCard?.paServiceRegister?.length, 5) || 0;
  const medicalSupplyCount =
    Math.min(
      values?.oldTreatmentPlanCard?.medicalSupplyOrders?.length,
      5 - serviceCount
    ) || 0;
  const drugCount =
    Math.min(
      values?.oldTreatmentPlanCard?.drugs?.length,
      5 - serviceCount - medicalSupplyCount
    ) || 0;

  const displayServices =
    values?.oldTreatmentPlanCard?.paServiceRegister?.slice(0, serviceCount);
  const displayMedicalSupply =
    values?.oldTreatmentPlanCard?.medicalSupplyOrders?.slice(
      0,
      medicalSupplyCount
    );
  const displayDrugs = values?.oldTreatmentPlanCard?.drugs?.slice(0, drugCount);
  return (
    <Grid container spacing={1} className="flex align-center justify-between">
      <Grid item xs={12} md={6}>
        <div className="flex mt-2" style={{ fontSize: "11px" }}>
          <div>
            Cần thu:{" "}
            <b style={{ color: "red" }}>
              {formatMoney(values?.oldTreatmentPlanCard?.amountActuallyPaid)}
            </b>
          </div>
          <span className="mx-2 text-gray-400">|</span>
          <div>
            Đã thu:{" "}
            <b style={{ color: "green" }}>
              {formatMoney(
                values?.oldTreatmentPlanCard?.totalBillPatientPaid || 0
              )}
            </b>
          </div>
          <span className="mx-2 text-gray-400">|</span>
          <div>
            {values?.oldTreatmentPlanCard?.clientCard?.code && (
              <div>
                <b style={{ color: "#007bff" }}>
                  {values?.oldTreatmentPlanCard?.clientCard?.code}{" "}
                </b>
              </div>
            )}
          </div>

          <span className="mx-2 text-gray-400">|</span>
        </div>
        <span className="clientCard-name">
          {values?.oldTreatmentPlanCard?.clientCard?.name}
        </span>
        {(displayServices || []).map((serviceItem, serviceIndex) => (
          <div className="flex items-center mb-1" style={{ fontSize: "10px" }}>
            <div
              className="flex items-center"
              style={{ borderBottom: "1px solid gray" }}
            >
              {serviceIndex + 1}.
              <span
                style={{
                  maxWidth: "200px",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                  display: "inline-block",
                  verticalAlign: "middle",
                }}
                title={serviceItem?.service?.tradeName || serviceItem?.service?.name || "Tên liệu trình"}
              >
                {serviceItem?.service?.tradeName || serviceItem?.service?.name || "Tên liệu trình"}
              </span>
              <CloseIcon fontSize="inherit" />
              <span className="value-medical">
                {serviceItem?.quantity || 1}
              </span>
              <span className="mx-2 text-gray-400">|</span>
              <div>
                Điều trị:{" "}
                {/* <b>{serviceItem?.totalPerformedTimes || 0}</b>{" "} */}
                {!serviceItem?.unLimited && (
                  <>
                    /
                    <b style={{ color: "red" }}>
                      {serviceItem?.totalTreatmentTimes || 0}
                    </b>
                  </>
                )}
              </div>
              {serviceItem?.unLimited && (
                <Tooltip title="Không giới hạn">
                  <span className="unlimited-badge">♾️</span>
                </Tooltip>
              )}
            </div>
          </div>
        ))}

        {(displayDrugs || []).map((serviceItem, serviceIndex) => (
          <div className="flex items-center mb-1" style={{ fontSize: "10px" }}>
            <div
              className="flex items-center"
              style={{ borderBottom: "1px solid gray" }}
            >
              {serviceCount + serviceIndex + 1}.
              <span
                style={{
                  maxWidth: "200px",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                  display: "inline-block",
                  verticalAlign: "middle",
                }}
                title={serviceItem?.drug?.name || "Tên thuốc"}
              >
                {serviceItem?.drug?.name || "Tên thuốc"}
              </span>
              <CloseIcon fontSize="inherit" />
              <span className="value-medical">
                {serviceItem?.soldQuantity || 1}
              </span>
              {serviceItem?.unLimited && (
                <span className="unlimited-badge">♾️ Không giới hạn</span>
              )}
            </div>
          </div>
        ))}

        {(displayMedicalSupply || []).map((serviceItem, serviceIndex) => (
          <div className="flex items-center mb-1" style={{ fontSize: "10px" }}>
            <div
              className="flex items-center"
              style={{ borderBottom: "1px solid gray" }}
            >
              {serviceCount + drugCount + serviceIndex + 1}.
              <span
                style={{
                  maxWidth: "200px",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                  display: "inline-block",
                  verticalAlign: "middle",
                }}
                title={serviceItem?.medicalSupply?.name || "Tên vật tư"}
              >
                {serviceItem?.medicalSupply?.name || "Tên vật tư"}
              </span>
              <CloseIcon fontSize="inherit" />
              <span className="value-medical">
                {serviceItem?.soldQuantity || 1}
              </span>
              {serviceItem?.unLimited && (
                <span className="unlimited-badge">♾️ Không giới hạn</span>
              )}
            </div>
          </div>
        ))}
      </Grid>

      <Grid item xs={12} md={2} className="">
        <GlobitsVNDCurrencyInput
          name="oldTreatmentCredit"
          label="Tiền khấu trừ liệu trình cũ"
          disabled
        />
      </Grid>
    </Grid>
  );
});

const PaymentVoucherButton = observer(
  ({
    isMobile,
    patient,
    treatmentPlanCard,
    listPaymentMethod,
    listStk,
    remainingAmount,
    customerSourceWalkIn,
    department,
  }) => {
    const {
      handleOpenPaymentVoucherPopup,
      openPaymentVoucherPopup,
      initialPaymentVoucher,
      createPaymentVoucherWithListMethod,
      handleClosePaymentVoucherPopup,
    } = useStore().feeStore.serviceFeeTabStore;

    return (
      <>
        <CommonButton
          className="btn"
          onClick={() => {
            handleOpenPaymentVoucherPopup(
              patient,
              listPaymentMethod,
              customerSourceWalkIn,
              department
            );
          }}
        >
          {!isMobile && <MoneyOffSharp className="mr-2 " />} Phiếu chi
        </CommonButton>
        {openPaymentVoucherPopup && (
          <PaymentVoucherPopup
            open={openPaymentVoucherPopup}
            handleClose={handleClosePaymentVoucherPopup}
            initialPaymentVoucher={{
              ...initialPaymentVoucher,
              treatmentPlanCard,
              totalAmount: remainingAmount,
            }}
            handleSubmit={createPaymentVoucherWithListMethod}
            patient={patient}
            listPaymentMethod={listPaymentMethod}
            listStk={listStk}
          />
        )}
      </>
    );
  }
);

const DialogErrorMessage = observer(() => {
  const { openInvalidMessage, handleCloseInvalidMessage } =
    useStore().patientManagementStore.registerTreatmentPlanStore;
  return (
    <>
      {!!openInvalidMessage && (
        <ConfirmPopup
          open={!!openInvalidMessage}
          onClose={() => handleCloseInvalidMessage(null)}
          text={openInvalidMessage}
          hideConfirm
          textClose={"Quay lại"}
          title="Thao tác thất bại"
        />
      )}
    </>
  );
});

export const renderOptionsTrement = (option) => {
  return (
    <div
      style={{
        gap: "16px",
        alignItems: "flex-start",
      }}
    >
      <div
        style={{
          minWidth: "100px",
          fontWeight: "bold",
          fontSize: "14px",
          color: "#000",
          wordBreak: "break-word",
        }}
      >
        {option?.tradeName || option?.name}
      </div>
      <div
        style={{
          flex: 1,
          display: "flex",
          flexWrap: "wrap",
          gap: "6px",
        }}
      >
        {option?.clientCardFees?.map((el, ind) => (
          <div
            key={ind}
            style={{
              fontSize: "10px",
              borderRadius: "6px",
              whiteSpace: "nowrap",
              backgroundColor: ind % 2 === 1 ? "#f1632159" : "#a8e1a8",
              padding: "2px",
              color: "#000",
            }}
          >
            {el?.patientTypeService?.name}:{" "}
            <strong>{el?.price?.toLocaleString("vi-VN") || 0}</strong>
          </div>
        ))}
      </div>
    </div>
  );
};
const DialogError = observer(({ patient, values, setFieldValue }) => {
  const { openConfirmMessage, handleCloseConfirmMessage } =
    useStore().patientManagementStore.registerTreatmentPlanStore;
  return (
    <>
      {!!openConfirmMessage && (
        <ConfirmPopup
          open={!!openConfirmMessage}
          onClose={() => {
            handleCloseConfirmMessage(null);
            if (!values?.id) {
              // khi đóng popup thì reset lại ngày đăng kí
              setFieldValue("startDate", new Date());
            }
          }}
          text={openConfirmMessage}
          onConfirm={() => {
            const url =
              Config.ROOT_PATH +
              PathModule.PATIENT_MANAGEMENT +
              `/patient-general?patientId=${patient?.id}`;

            window.open(url, "_blank");
          }}
          textConfirm={"Thông tin khách"}
          textClose={"Quay lại"}
          title="Thao tác thất bại"
          isNotAPromise
        />
      )}
    </>
  );
});

const PromotionProgram = observer(({ initialValues, setFieldValue }) => {
  const {
    promotionPrograms,
    applyPromotion,
    openFormFreePromotion,
    handleCloseFormFreePromotion,
    handleOpenFormFreePromotion,
    handleChangeFormSearchPromotionProgram,
    searchPromotionProgramVoucher,
  } = useStore().feeStore.serviceFeeTabStore;

  function getNotEnoughItems(dataVoucher, initialValues) {
    const result = {
      services: [],
      drugs: [],
    };

    // Không có sản phẩm áp dụng → return rỗng
    if (
      !Array.isArray(dataVoucher?.products) ||
      dataVoucher.products.length === 0
    ) {
      return result;
    }

    // Kiểm tra dịch vụ
    if (
      Array.isArray(initialValues?.paServiceRegister) &&
      initialValues.paServiceRegister.length > 0
    ) {
      for (const productApply of dataVoucher.products ?? []) {
        if (!productApply?.product) continue;

        const matchedService = initialValues.paServiceRegister.find(
          (serviceRegister) =>
            serviceRegister?.service?.code === productApply?.product?.code
        );

        const required = productApply?.promoteQuantity ?? 0;
        const current = matchedService?.quantity ?? 0;

        if (matchedService && current < required) {
          result.services.push({
            name: productApply.product.name ?? "",
            required,
            current,
          });
        }
      }
    }

    // Kiểm tra sản phẩm (drug)
    if (Array.isArray(initialValues?.drugs) && initialValues.drugs.length > 0) {
      for (const productApply of dataVoucher.products ?? []) {
        if (!productApply?.product) continue;

        const matchedDrug = initialValues.drugs.find(
          (drugRegister) =>
            drugRegister?.drug?.code === productApply?.product?.code
        );

        const required = productApply?.promoteQuantity ?? 0;
        const current = matchedDrug?.quantity ?? 0;

        if (matchedDrug && current < required) {
          result.drugs.push({
            name: productApply.product.name ?? "",
            required,
            current,
          });
        }
      }
    }

    return result;
  }

  // Ấn áp dụng
  const handleApplyPromotion = async (obj) => {
    if (!initialValues) {
      return;
    }
    let dataVoucher = null;
    if (obj?.selectedVoucher) {
      if (
        obj?.selectedVoucher?.promotionType === PromotionTypeEnum.VOUCHER.value
      ) {
        dataVoucher = obj?.selectedVoucher;
      } else {
        let { data } = await pagingProgramGetId(obj?.selectedVoucher?.id);
        dataVoucher = data;
      }
    }

    // Kiểm tra số lượng sản phẩm được áp dụng theo CTKM
    const notEnough = getNotEnoughItems(dataVoucher, initialValues);
    if (notEnough.services.length > 0 || notEnough.drugs.length > 0) {
      notEnough.services.forEach((item) => {
        toast.warning(
          `Dịch vụ "${item.name}" cần số lượng tối thiểu ${item.required} để áp dụng CTKM, hiện tại số lượng có ${item.current}`
        );
      });

      notEnough.drugs.forEach((item) => {
        toast.warning(
          `Sản phẩm "${item.name}" cần số lượng tối thiểu ${item.required} để áp dụng CTKM, hiện tại số lượng có  ${item.current}`
        );
      });

      return;
    }
    // thực hiện lưu áp dụng CTKM cho dv/sp
    try {
      const payload = {
        ...obj,
        promotionProgramDto: {
          ...dataVoucher,
          promotionCode: searchPromotionProgramVoucher?.promotionCode,
        },
      };

      const { paServiceRegister, drugs } = await applyPromotion(payload);

      let discount = 0;
      // let taxTotal = 0;
      let totalAmount = 0; // tính lại các trường giá ở trên
      const formatService = paServiceRegister?.map((el) => {
        totalAmount += +(el?.price * el?.quantity) || 0;
        discount += +el?.discount || 0;
        // taxTotal += +el?.taxTotal || 0;
        return {
          ...el,
          amount: el?.amountActuallyPaid,
          isDisabledCTKM:
            el?.promotionProgram &&
            el?.promotionProgram?.code !== PROMOTION_DEFAULT_CODE &&
            !PROMOTION_CODES?.includes(el?.promotionProgram?.code),
          patientTypeService: {
            ...el?.patientTypeService,
            id: el?.patientTypeService?.id,
          },
        };
      });

      const formatDrugs = drugs?.map((el) => {
        totalAmount += +(el?.price * el?.soldQuantity) || 0;
        discount += +el?.discount || 0;
        // taxTotal += +el?.taxTotal || 0;
        return {
          ...el,
          amount: el?.amountActuallyPaid,
          isDisabledCTKM:
            el?.promotionProgram &&
            el?.promotionProgram?.code !== PROMOTION_DEFAULT_CODE &&
            !PROMOTION_CODES?.includes(el?.promotionProgram?.code),
          patientTypeService: {
            ...el?.patientTypeService?.patientTypeService,
            id: el?.patientTypeService?.id,
          },
        };
      });
      setFieldValue("paServiceRegister", formatService);
      setFieldValue("drugs", formatDrugs);
      setFieldValue("totalAmount", totalAmount);
      // setFieldValue("taxTotal", taxTotal);
      setFieldValue("discount", discount);
      setFieldValue("selectedVoucher", dataVoucher);
      handleCloseFormFreePromotion();
    } catch (error) {
      console.error("❌ Lỗi khi áp dụng CTKM:", error);
      toast.error("Áp dụng chương trình khuyến mãi thất bại!");
    }
  };

  return (
    <>
      <Button
        variant="outlined"
        color="primary"
        onClick={() => {
          if (
            initialValues?.paServiceRegister?.length > 0 ||
            initialValues?.drugs?.length > 0
          ) {
            handleOpenFormFreePromotion();
          } else {
            toast.warning("Vui lòng chọn dịch vụ");
          }
        }}
      >
        Chọn chương trình khuyến mãi
      </Button>

      {openFormFreePromotion && (
        <PromotionFreePopup
          handleClose={handleCloseFormFreePromotion}
          handleSubmit={handleApplyPromotion}
          initialValues={initialValues}
          open={openFormFreePromotion}
          promotionPrograms={promotionPrograms}
          handleChangeFormSearchPromotionProgram={
            handleChangeFormSearchPromotionProgram
          }
        />
      )}
    </>
  );
});

const ButtonDeleteProgram = observer(({ values, setFieldValue }) => {
  const { applyPromotion } = useStore().feeStore.serviceFeeTabStore;
  return (
    <>
      <Tooltip title="Xóa chương trình khuyến mãi">
        <div
          className="flex align-center gap-1"
          onClick={async () => {
            const { paServiceRegister, drugs } = await applyPromotion({
              ...values,
              promotionProgramDto: null,
            });

            let discount = 0;
            // let taxTotal = 0;
            let totalAmount = 0; // tính lại các trường giá ở trên
            const formatService = paServiceRegister?.map((el) => {
              totalAmount += +(el?.price * el?.quantity) || 0;
              discount += +el?.discount || 0;
              // taxTotal += +el?.taxTotal || 0;
              return {
                ...el,
                amount: el?.amountActuallyPaid,
              };
            });

            const formatDrugs = drugs?.map((el) => {
              totalAmount += +(el?.price * el?.soldQuantity) || 0;
              discount += +el?.discount || 0;
              // taxTotal += +el?.taxTotal || 0;
              return {
                ...el,
                amount: el?.amountActuallyPaid,
              };
            });
            setFieldValue("paServiceRegister", formatService);
            setFieldValue("drugs", formatDrugs);
            setFieldValue("totalAmount", totalAmount);
            setFieldValue("discount", discount);
            setFieldValue("selectedVoucher", null);
          }}
        >
          <IconDelete />
        </div>
      </Tooltip>{" "}
    </>
  );
});
export default memo(observer(RegisterTreatmentPlanPopupTotalItem));
